import { Flex } from '@chakra-ui/react'
import { useApolloClient } from '@apollo/client'

import { Loading } from 'components'

import { useOAuthCallback } from '../hooks'

export const OAuthCallback = ({ children }) => {
  const client = useApolloClient()
  useOAuthCallback({
    onError: async error => {
      console.error(error)
      await client.clearStore()
      await client.cache.gc()
      window.location.href = '/'
    },
    onSuccess: async () => {
      await client.resetStore()
      window.location.href = '/'
    }
  })

  return (
    <Flex minHeight='100vh' direction='column'>
      <Loading flex={1} height='100%' />
    </Flex>
  )
}

export default OAuthCallback
